<template>
  <div>
    <el-row class="articleContent" ref="print" id="print">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/admin-license' }"
            >行政审批
          </el-breadcrumb-item>
          <el-breadcrumb-item>{{
            articleInfo.articleTitle
          }}</el-breadcrumb-item>
        </el-breadcrumb>
        <p class="header">{{ articleInfo.articleTitle }}</p>
        <div class="printButton">
          <el-button
            style="font-size: 16px"
            class="themeButton"
            @click="dealOnline"
            v-if="hasZxbl === '1'"
          >
            在线办理
            <!--          <a-->
            <!--            href="http://gl.ncha.gov.cn:9001/login?code=90000&flag=false"-->
            <!--            target="_blank"-->
            <!--          >-->
            <!--            在线办理</a>-->
          </el-button>
          <div v-else></div>
          <el-button style="font-size: 16px" class="themeButton" @click="pri"
            >打印本页
          </el-button>
        </div>
        <div class="readCountLabel" style="margin-bottom: 15px"></div>
        <form_common
          id="wen-type"
          :judge="judge"
          :activeKey="0"
          :tabList="tabList1"
        >
          <div slot="form" ref="form">
            <div class="item-content">
              <h4>基本信息</h4>
              <mailTable
                :tableData="tableDataOne"
                :showByRow="showByRowOne"
              ></mailTable>
              <mailTable
                :tableData="tableDataTwo"
                :showByRow="showByRowTwo"
              ></mailTable>
            </div>
            <div class="item-content">
              <h4 class="h4">
                <span>办理流程</span>
                <el-button
                  v-show="dialo"
                  type="text"
                  @click="dialogVisible = true"
                  >查看流程图
                </el-button>
              </h4>
              <el-card class="box-card textident"
                >{{ writtenWords.processPath }}
              </el-card>
            </div>
            <div class="item-content">
              <h4>办理材料目录</h4>
              <!-- :span-method="arraySpanMethod" -->
              <el-table
                :data="applyForm"
                border
                fit
                class="applyF"
                :header-cell-style="{
                  background: '#ebe6db',
                  color: '#585856',
                  borderColor: '#585856',
                }"
                :cell-style="{ borderColor: '#585856' }"
              >
                <el-table-column
                  align="center"
                  prop="materialsName"
                  label="材料名称"
                  min-width="270px"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="materialsSample"
                  label="材料填写样本"
                  min-width="460px"
                >
                  <template slot-scope="scope"
                    >         
                    <el-link
                      v-show="scope.row.materialsSample == '样表下载'"
                      target="_blank"
                      :underline="false"
                    >
                      <!-- :href="item.sourceUrl | filterUrl" -->
                      <el-button
                        class="elbtn"
                        @click="downloadForm(scope.row.materialsName)"
                        >{{ scope.row.materialsSample }}
                      </el-button>
                    </el-link>
                    <span v-show="scope.row.materialsSample !== '样表下载'">{{
                      scope.row.materialsSample
                    }}</span
                    >                   
                  </template>
                </el-table-column>

                <el-table-column
                  align="center"
                  prop="materialsChannel"
                  label="来源渠道"
                  min-width="130px"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="paperMaterials"
                  label="纸质材料"
                  min-width="100px"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="materialsNecessity"
                  label="材料必要性"
                  min-width="130px"
                >
                </el-table-column>
              </el-table>
            </div>
            <div class="item-content">
              <h4>禁止性要求</h4>
              <el-card class="box-card textident"
                >{{ writtenWords.prohibitiveRequirements }}
              </el-card>
            </div>
            <div class="item-content">
              <h4>受理条件</h4>
              <el-card class="box-card textident"
                >{{ writtenWords.acceptCondition }}
              </el-card>
            </div>
            <div class="item-content">
              <h4>收费标准</h4>
              <el-card class="box-card textident"
                >{{ writtenWords.chargeNorm }}
              </el-card>
            </div>
            <div class="item-content">
              <h4>设定依据</h4>
              <el-card class="box-card textident"
                >{{ writtenWords.setGist }}
              </el-card>
            </div>
            <div class="item-content">
              <h4>常见问题</h4>
              <textarea
                class="box-card textident"
                style="width: 100%; height: 700px; text-indent: 0"
                v-model="writtenWords.commonQuestion"
              ></textarea>
            </div>
          </div>
        </form_common>
        <div class="readCountLabel"></div>
        <div class="printButton">
          <el-button
            style="font-size: 16px"
            class="themeButton"
            @click="dealOnline"
            v-if="hasZxbl === '1'"
          >
            在线办理
            <!--          <a-->
            <!--            :href="jumpAddress"-->
            <!--            target="_blank"-->
            <!--            ref="dealOnline"-->
            <!--          >-->
            <!--            在线办理</a-->
            <!--          >-->
          </el-button>
          <div v-else></div>
          <el-button style="font-size: 16px" class="themeButton" @click="pri"
            >打印本页
          </el-button>
        </div>
      </el-col>

      <el-dialog title="查看流程图" :visible.sync="dialogVisible" width="65%">
        <div style="text-align: center">
          <!--        <div class="liuImage2">-->
          <!--          <img style="width: 100%; height: 100%" :src="i" alt="" />-->
          <!--        </div>-->
          <el-image :src="i"></el-image>
        </div>
        <!-- {{ i }} -->
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import mailTable from "../../components/Table/tableCompontent";
import form_common from "../../components/Home/form_common";
import { jumpAddress } from "../../utils/axiosUrl";
import {
  URL_BUSINESS_GUIDE,
  URL_ECHO_PICTURE,
  URL_MATTER_ID,
} from "../../utils/api";
import util from "../../utils/util";
import { frontHeater } from "../../utils/md5encryption";

export default {
  name: "ArticleContent",
  components: {
    "information-inquiry": () =>
      import("@/components/Home/InformationInquiry/InformationInquiry.vue"),
    mailTable,
    form_common,
  },
  data() {
    return {
      jumpAddress: jumpAddress,
      tabList1: [],
      // 静态数据
      tabList: [
        { label: "基本信息", value: "one" },
        { label: "办理流程", value: "two" },
        { label: "办理材料目录", value: "three" },
        { label: "禁止性要求", value: "four" },
        { label: "受理条件", value: "five" },
        { label: "收费标准", value: "six" },
        { label: "设定依据", value: "seven" },
        { label: "常见问题", value: "eight" },
      ],
      // 接受数据
      articleInfo: {
        articleId: "",
        articleTitle: "", //面包屑第二位
      },
      // 基本信息
      tableDataOne: [
        { key: "事项类型", value: "" },
        { key: "办证类型", value: "" },
        { key: "实施主体", value: "" },
        { key: "行政层级", value: "" },
        { key: "决定机构", value: "" },
        { key: "审查类型", value: "" },
        { key: "申请主体", value: "" },
        { key: "受理机构", value: "" },
        { key: "承诺办结时限", value: "" },
        { key: "法定办结时限", value: "" },
        { key: "是否收费", value: "" },
        { key: "到办事现场次数", value: "" },
        { key: "数量限制", value: "" },
        { key: "适用范围", value: "" },
        { key: "审批结果及送达方式", value: "" },
        { key: "办理进程和结果查询", value: "" },
      ],
      showByRowOne: true,
      tableDataTwo: [
        { key: "咨询方式", value: "" },
        { key: "监管投诉渠道", value: "" },
        { key: "办理时间", value: "" },
        { key: "办理地点", value: "" },
      ],
      showByRowTwo: false,
      // 流程图开关
      dialogVisible: false,
      // 总数据
      writtenWords: [],
      download: false,
      // 表格内容
      applyForm: [],
      // 判断是哪种方式进入此页面
      judge: "",
      // 获取事项img 路径
      image: "",
      i: "",
      imgUrl: "",
      dialo: true,
      reportFrom: [],
      hasZxbl: "",
    };
  },
  created() {
    this.hasZxbl = this.$route.query.hasZxbl;
  },
  methods: {
    dealOnline() {
      window.open(jumpAddress, "_blank");
    },
    pri() {
      this.$print(this.$refs.print);
    },
    downloadForm(materialsName) {
      this.reportFrom.forEach((item) => {
        const fileName = item.fileOrigName.split(".")[0];
        if (fileName == materialsName) {
          this.downloadReport(item.bid, item.fileType);
        }
      });
    },

    // 请求列表数据
    getList() {
      let result = frontHeater(["itemCode"], [this.$route.query.id]);
      let itemCode = this.$route.query.id;
      let Url = util.getAjaxUrl("axiosTWo");
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["itemCode"] = this.$route.query.id;
      this.$http.get(`${Url}${URL_BUSINESS_GUIDE}/${itemCode}`).then((resp) => {
        if (resp.status === 200) {
          console.log(resp);
          this.writtenWords = resp.data;
          this.tableDataOne[0].value = resp.data.itemType;
          this.tableDataOne[1].value = resp.data.projectType;
          this.tableDataOne[2].value = resp.data.implementationSubject;
          this.tableDataOne[3].value = resp.data.administrativeLevel;
          this.tableDataOne[4].value = resp.data.decisionMechanism;
          this.tableDataOne[5].value = resp.data.examineType;
          this.tableDataOne[6].value = resp.data.applySubject;
          this.tableDataOne[7].value = resp.data.acceptInstitution;
          this.tableDataOne[8].value = resp.data.commitmentDeadline;
          this.tableDataOne[9].value = resp.data.statutoryDeadline;
          this.tableDataOne[10].value = resp.data.charge;
          this.tableDataOne[11].value = resp.data.projectSceneNumber;
          this.tableDataOne[12].value = resp.data.quantitativeLimitation;
          this.tableDataOne[13].value = resp.data.applicationRang;
          this.tableDataOne[14].value = resp.data.projectResult;
          this.tableDataOne[15].value = resp.data.handleProcess;
          this.tableDataTwo[0].value = resp.data.consultingWay;
          this.tableDataTwo[1].value = resp.data.complaintChannels;
          this.tableDataTwo[2].value = resp.data.processTime;
          this.tableDataTwo[3].value = resp.data.processAddress;

          this.getProps();
          this.getIdList();
        }
      });
    },
    // 根据事项id获取附件列表
    getIdList() {
      let result = frontHeater(["id"], [this.writtenWords.id]);
      let id = this.writtenWords.id;
      let Url = util.getAjaxUrl("axiosOne");
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["id"] = this.writtenWords.id;
      this.$http.get(`${Url}${URL_MATTER_ID}?BId=${id}`).then((resp) => {
        if (resp.status === 200) {
          if (resp.data.data != null) {
            for (let v of Object.values(resp.data.data)) {
              v.forEach((item) => {
                if (item.fileSuffix != ".docx") {
                  this.image = item.filePath;
                  this.getImageList();
                } else {
                  this.reportFrom.push(item);
                }
              });
            }
          } else {
            this.dialo = false;
          }
        }
      });
    },
    // 请求回显图片
    getImageList() {
      let path = this.image;
      // let Url = util.getAjaxUrl("axiosOne");
      this.$util
        .ajaxWithFile(`${URL_ECHO_PICTURE}?path=${path}`, "get", {}, "axiosOne")
        .then((res) => {
          this.i = res.request.responseURL;
        });
    },
    //报表下载请求
    downloadReport(bid, fileType) {
      let Url = util.getAjaxUrl("axiosFour");
      console.log(Url);
      window.open(
        `${Url}/api/print/download?id=${bid}&fileType=${fileType}`,
        "_blank"
      );
    },
    // 遍历获取表格数据
    getProps() {
      let arr = [];
      this.writtenWords.approvalItemGuideComs.forEach((item) => {
        return item.materials.forEach((item) => {
          arr.push(item);
        });
      });
      this.applyForm = arr;
    },
  },
  mounted() {
    this.articleInfo.articleId = this.$route.query.id;
    this.articleInfo.articleTitle = this.$route.query.type;
    this.getList();
    if (this.$route.query.question == 1) {
      this.judge = 1;
      this.tabList1 = this.tabList;
    } else {
      this.tabList1 = this.tabList;
    }
  },
};
</script>

<style scoped lang="less">
@import "../../styles/theme";
@import "../../styles/comSty";

#articleContent {
  overflow: inherit;
}

.printButton {
  width: 100%;
  display: flex;
  margin: 10px 0;
  justify-content: space-between;
}

.themeButton {
  background-color: @background-color;
  border-color: @border-color;
  color: @title-color;
  padding: 9px 15px;
  float: right;
  font-size: 12px;
}

.themeButton:hover {
  border-color: #c54949;
  color: @dark-theme-color;
}

.readCountLabel {
  border-bottom: 5px solid @theme-color;
}

.header {
  padding: 8px 0;
  text-align: center;
  font-size: 18px;
  margin-top: 10px;
  font-weight: bolder;
}

h4 {
  text-align: left;
  font-size: 15px;
  font-weight: 700;
  margin: 10px 0;
  padding: 10px;
  background-color: #f2f2f2;
}

.h4 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/deep/ .el-card__body {
  padding-left: 0px;
}

p {
  text-indent: 30px;
}

.elbtn {
  border-color: #b71c1c;
  color: #b71c1c;
  background-color: #f8e8e8;
  font-size: 12px;
  cursor: pointer;
}

.elbtn:hover {
  background-color: #b71c1c;
  color: white;
}

@media print {
  .applyF {
    width: 100%;
    height: 100%;
  }
}

.liuImage {
  width: 100%;
  height: 500px;
}

.liuImage2 {
  height: 500px;
  text-align: center;
  // height: 200px;
}
</style>
